import React, { useState } from "react";
import { useContext } from "react";
import { Link, useLocation } from "react-router-dom";

import "./Navbar.css";
import { AuthContextTwo } from "../../../contexts/AuthProviderTwo";

const Navbar = () => {
  const { user, logout } = useContext(AuthContextTwo);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const [activeLink, setActiveLink] = useState(null);

  const handleSetActiveLink = (link) => {
    setActiveLink(link);
  };

  // State to manage sidebar visibility
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  // Function to toggle sidebar visibility
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const location = useLocation();

  const shouldHideLabel =
    location.pathname === "/jobBoard" ||
    location.pathname.startsWith("/jobBoardDetails") ||
    location.pathname.startsWith("/dashboardTwo");

  const showHideLabel = location.pathname.startsWith("/dashboardTwo");

  const shouldHideLabelTwo =
    location.pathname === "/jobBoard" ||
    location.pathname === "/jobBoardDetails";

  // const homeNav = location.pathname === "/" || location.pathname === "/login" || location.pathname === "/signup";
  // const maxWidthClasses = homeNav ? "max-w-[1320px] mx-auto" : "";

  return (
    <div>
      {!shouldHideLabel ? (
        <div>
          <header className="text-gray-900 desktop-components body-font shadow-sm bg-white border-b border-green-300">
          <div className="flex flex-row justify-between mx-auto lg:w-[70%] md:w-[90%] sm:w-[95%] items-center py-4">
            <Link to="/">
              <div>
                <h1 className="lg:text-2xl md:text-lg sm:text-md  font-marcellus text-green-800 text600">
                  Tutor Tree
                </h1>
              </div>
            </Link>

            <div>
              <div className="lg:flex-row lg:flex lg:gap-5 md:hidden sm:hidden">
                <Link to="/login">
                  <button className="px-4 py-2  rounded-lg  text-green-800 font-roboto text-lg  duration-150">
                    Login
                  </button>
                </Link>
                <Link to="/signup">
                  <button className="px-4 py-2 bg-green-600 rounded-lg  text-white font-roboto text-lg hover:bg-green-900 duration-150">
                    Sign Up
                  </button>
                </Link>
              </div>
              <div className="">
                <button
                  className="lg:text-white sm:mt-2 md:hidden lg:hidden"
                  onClick={toggleSidebar}
                >
                  <img
                    className="w-10 h-10"
                    src="https://i.ibb.co/bNWyCBy/menu.png"
                    alt=""
                  ></img>
                </button>
                <div className={`sidebar ${isSidebarOpen ? "open" : ""}`}>
                  <div className="flex justify-center gap-5 items-start flex-col px-5 py-10">
                    <Link
                      to="/"
                      className={`text-2xl font-courierPrime text-white ${
                        activeLink === "/" ? "text-yellow-300" : ""
                      }`}
                      onClick={() => handleSetActiveLink("/")}
                    >
                      Home
                    </Link>
                    <Link
                      to="/projects"
                      className={`text-2xl font-courierPrime text-white ${
                        activeLink === "/projects" ? "text-yellow-300" : ""
                      }`}
                      onClick={() => handleSetActiveLink("/projects")}
                    >
                      Projects
                    </Link>
                    <Link
                      to="/team"
                      className={`text-2xl font-courierPrime text-white ${
                        activeLink === "/team" ? "text-yellow-300" : ""
                      }`}
                      onClick={() => handleSetActiveLink("/team")}
                    >
                      Team
                    </Link>

                    <Link
                      to="/about-me"
                      className={`text-2xl font-courierPrime text-white ${
                        activeLink === "/about-me" ? "text-yellow-300" : ""
                      }`}
                      onClick={() => handleSetActiveLink("/about-me")}
                    >
                      About Me
                    </Link>
                    <Link
                      to="/contact"
                      className={`text-2xl font-courierPrime text-white ${
                        activeLink === "/contact" ? "text-yellow-300" : ""
                      }`}
                      onClick={() => handleSetActiveLink("/contact")}
                    >
                      Contact
                    </Link>
                  </div>
                </div>
                <div
                  className={`overlay ${isSidebarOpen ? "active" : ""}`}
                  onClick={toggleSidebar}
                ></div>
              </div>
            </div>
          </div>
          <div className="mx-auto sm:hidden lg:w-[55%] md:w-[90%] sm:w-[95%] py-4 border-y border-y-gray-500 flex justify-around border-x-2 border-x-gray-400">
            <Link
              to="/"
              className={`text-2xl font-courierPrime text-white ${
                activeLink === "/" ? "text-yellow-300" : ""
              }`}
              onClick={() => handleSetActiveLink("/")}
            >
              Home
            </Link>
            <Link
              to="/projects"
              className={`text-2xl font-courierPrime text-white ${
                activeLink === "/projects" ? "text-yellow-300" : ""
              }`}
              onClick={() => handleSetActiveLink("/projects")}
            >
              Projects
            </Link>
            <Link
              to="/team"
              className={`text-2xl font-courierPrime text-white ${
                activeLink === "/team" ? "text-yellow-300" : ""
              }`}
              onClick={() => handleSetActiveLink("/team")}
            >
              Team
            </Link>

            <Link
              to="/about-me"
              className={`text-2xl font-courierPrime text-white ${
                activeLink === "/about-me" ? "text-yellow-300" : ""
              }`}
              onClick={() => handleSetActiveLink("/about-me")}
            >
              About Me
            </Link>
            <Link
              to="/contact"
              className={`text-2xl font-courierPrime text-white ${
                activeLink === "/contact" ? "text-yellow-300" : ""
              }`}
              onClick={() => handleSetActiveLink("/contact")}
            >
              Contact
            </Link>
          </div>
          </header>
          {/* <header className="mobile-component">
            
          </header> */}
        </div>
      ) : (
        ""
      )}
  </div>
  );
};

export default Navbar;
